{
    "Profile_SupernovaCommercial_Insureds_Insured.additionalInsuredDetails": "Additional Insured details",
    "Profile_SupernovaCommercial_Insureds_Insured.businessName": "Business Name",
    "Profile_SupernovaCommercial_Insureds_Insured.reasonRequired": "Reason they are required to be added as an additional insured",
    "Profile_SupernovaCommercial_Insureds_Insured.addressDetails": "Address Details",
    "Profile_SupernovaCommercial_Insureds_Insured.locationDetails": "Location Details"
}
